
export function validate(rule, data, fieldNamePath, allFieldsData, allFieldsValidationInfos, ignoreImplicitRuleFields = []) {
    let rules = rule.split('|');
    let forceTrue = false;

    const getImplicitFieldInfo = function(field) {
        let fieldsData = Object.assign({}, allFieldsData);
        let namePath = fieldNamePath.slice(0);
        let baseName = null;
        let ignored = false;
        
        let namePatternMappingRegex = /\(((?:.(?!=>))+.)=>([^\)]+)\)/;
        field = field.replace(namePatternMappingRegex, (match, p1, p2) => {
            baseName = p2.trim();
            return p1.trim();
        });
    
        let segments = field.split('.');
    
        segments.every(segment => {
            if(baseName == null) {
                baseName = segment;
    
                if(baseName == '*') {
                    baseName = namePath[0];
                } else if(baseName == '?') {
                    Object.keys(allFieldsData).forEach(fieldKey => {
                        if(fieldKey != namePath[0]) {
                            baseName = fieldKey;
                        }
                    });
                }
            }
    
            if(ignoreImplicitRuleFields.indexOf(baseName) != -1) {
                fieldsData = true;
                ignored = true;
                return false;
            }
    
            if(fieldsData && typeof fieldsData == 'object') {
                let fieldNamePathSegment = namePath.pop();
    
                if(segment === '*') {
                    fieldsData = (fieldNamePathSegment in fieldsData) ? fieldsData[fieldNamePathSegment] : undefined;
                } else if(segment === '?') {
                    if(baseName in allFieldsValidationInfos) {
                        fieldsData = Object.values(fieldsData).find(d => validate(allFieldsValidationInfos[baseName].validation, d, allFieldsValidationInfos[baseName].namePath, allFieldsData, allFieldsValidationInfos, [ fieldNamePath[0] ]));
                    }
                } else if(segment in fieldsData) {
                    fieldsData = fieldsData[segment];
                }
    
                return fieldsData === undefined ? false : true;
            } else {
                return false;
            }
        });
    
        return {
            data: fieldsData,
            baseName: baseName,
            ignored: ignored,
            segments: segments
        };
    };

    const validations = {
        required(d) {
            switch(typeof d) {
                case 'undefined': return false;
                    break;
                case 'string': return d.trim().length > 0;
                    break;
                case 'object': return d != null;
                    break;
                case 'boolean':
                case 'number': return d.toString().trim().length > 0;
                    break;
            }
            
            return false;
        },
        required_without_all(d, f) {
            let r = true;
            let successResult = 1;
    
            f.forEach(field => {
                let fieldInfo = getImplicitFieldInfo(field); 
                r = r && validations.required(fieldInfo.data);
                successResult = fieldInfo.ignored ? true : 1;
            });
    
            return r ? successResult : validations.required(d);
        },
        email(d) {
            let re = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{1,})$/i;
            return re.test(d);
        },
        in(d, v) {
            return v.indexOf(d) !== -1;
        },
        contains(d, v) {
            const data = typeof d == 'object' ? Object.values(d) : null;
    
            return data && v.every(p => data.some(q => q == p));
        }
    };

    let failedRules = [];

    let result =  rules.every(rule => {
        let ruleParts = rule.split(';', 2);
        rule = ruleParts.length > 1 ? ruleParts[1] : ruleParts[0];
        ruleParts = rule.split(':');
        rule = ruleParts[0];
        let ruleProps = ruleParts.length > 1 ? ruleParts[1].split(',') : null;

        if(rule in validations) {
            let ruleResult = validations[rule](data, ruleProps);

            if(!ruleResult) {
                failedRules.push(rule);
            }

            if(ruleResult === 1 && !validations.required(data)) {
                forceTrue = true;
                return false;
            } else {
                return ruleResult;
            }
        }
    });

    return result || forceTrue ? true : failedRules;
}